import { authFetch } from "../utils/AuthFetch";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
const token = localStorage.getItem('user_token');

export const getUserNotification = async () => {
    const response = await authFetch(`${API_BASE_URL}/notifications/unread-count/user`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch reservations');
    }

    const data = await response.json();
  
    return data.body.unread_count;
  };

export const getUnreadCountBySpaces = async () => {
    const response = await authFetch(`${API_BASE_URL}/notifications/unread-count/spaces`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            },
        });

    if (!response.ok) {
        throw new Error('Failed to fetch unread count by spaces');
    }

    const data = await response.json();

    return data.body.unread_by_spaces;
}

export const getUnreadCountByReservations = async (reservationIds: number[]) => {
    const token = localStorage.getItem('user_token');
  
    const response = await authFetch(`${API_BASE_URL}/notifications/unread-count/reservations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ reservationIds }),
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch unread count by reservations');
    }
  
    const data = await response.json();
  
    return data.body.unread_by_reservations as { [key: number]: number };
  };

export const markNotificationAsRead = async (reservationId: number) => {
    const token = localStorage.getItem('user_token');

    const response = await authFetch(`${API_BASE_URL}/notifications/mark-as-read`, {
        method: 'PATCH',
        headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ reservation_id : reservationId }),
    });

    if (!response.ok) {
        throw new Error('Failed to mark notifications as read');
    }

    const data = await response.json();

    return
}